module.exports = __webpack_public_path__ + "static/sign-up-form-1-1-77ef3505267f727567c68fce5cbd3387.png";